import { Type } from "class-transformer";
import { ConsumableDto } from "../consumables/consumable.dto";
import { ItemModelDto } from "../item-models/item-model.dto";
import { ExtractedPurchaseOrderLineStatus } from "./extracted-purchase-order-line-status.enum";

export class ExtractedPurchaseOrderLineDto {
  status: ExtractedPurchaseOrderLineStatus;
  rawDescription: string;
  message?: string;
  externalReference?: string;
  quantity: number;
  unitPrice: number;
  confidence?: number;
  consumableId?: string;

  @Type(() => ConsumableDto)
  consumable?: ConsumableDto;

  itemModelId?: string;

  @Type(() => ItemModelDto)
  itemModel?: ItemModelDto;
}
